// ============================================================================
// src/app/data/pigSeedData.ts — seed records for the pig program.
// ============================================================================
// Pure data. Historical Podio-export rows used as the first-run defaults for
// PigProvider's breeders and farrowing state; localStorage supersedes them on
// every subsequent boot. Extracted from src/main.jsx in B2.1 unchanged.
// ============================================================================

export const INITIAL_BREEDERS = [
  {
    id: 'podio-1',
    tag: '1',
    sex: 'Boar',
    group: '',
    status: 'Boar Group',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2023-01-15',
    lastWeight: '393',
    purchaseDate: '2023-04-15',
    purchaseAmount: '750',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-2',
    tag: '2',
    sex: 'Sow',
    group: '2',
    status: 'Sow Group',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2022-02-01',
    lastWeight: '444',
    purchaseDate: '2022-04-01',
    purchaseAmount: '750',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-3',
    tag: '3',
    sex: 'Sow',
    group: '1',
    status: 'Sow Group',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2023-02-15',
    lastWeight: '285',
    purchaseDate: '2023-04-15',
    purchaseAmount: '750',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-4',
    tag: '4',
    sex: 'Sow',
    group: '',
    status: 'Deceased',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2022-02-01',
    lastWeight: '570',
    purchaseDate: '2022-04-01',
    purchaseAmount: '750',
    notes: '',
    archived: true,
  },
  {
    id: 'podio-5',
    tag: '5',
    sex: 'Sow',
    group: '2',
    status: 'Sow Group',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2022-02-01',
    lastWeight: '644',
    purchaseDate: '2022-04-01',
    purchaseAmount: '750',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-6',
    tag: '6',
    sex: 'Sow',
    group: '1',
    status: 'Sow Group',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2023-02-15',
    lastWeight: '370',
    purchaseDate: '2023-04-15',
    purchaseAmount: '750',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-7',
    tag: '7',
    sex: 'Sow',
    group: '1',
    status: 'Sow Group',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2023-02-15',
    lastWeight: '315',
    purchaseDate: '2023-04-15',
    purchaseAmount: '750',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-8',
    tag: '8',
    sex: 'Sow',
    group: '2',
    status: 'Deceased',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2022-02-01',
    lastWeight: '416',
    purchaseDate: '2022-04-01',
    purchaseAmount: '750',
    notes: '',
    archived: true,
  },
  {
    id: 'podio-9',
    tag: '9',
    sex: 'Sow',
    group: '3',
    status: 'Sow Group',
    breed: 'Duroc/Berkshire Cross',
    origin: 'Born on Farm',
    birthDate: '2023-05-17',
    lastWeight: '374',
    purchaseDate: '',
    purchaseAmount: '',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-10',
    tag: '10',
    sex: 'Sow',
    group: '2',
    status: 'Sow Group',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2022-02-01',
    lastWeight: '610',
    purchaseDate: '2022-04-01',
    purchaseAmount: '750',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-11',
    tag: '11',
    sex: 'Sow',
    group: '3',
    status: 'Sow Group',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2023-02-15',
    lastWeight: '387',
    purchaseDate: '2023-04-15',
    purchaseAmount: '750',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-13',
    tag: '13',
    sex: 'Sow',
    group: '2',
    status: 'Sow Group',
    breed: 'Duroc/Berkshire Cross',
    origin: 'Born on Farm',
    birthDate: '2023-05-17',
    lastWeight: '373',
    purchaseDate: '',
    purchaseAmount: '',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-17',
    tag: '17',
    sex: 'Sow',
    group: '1',
    status: 'Sow Group',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2023-02-15',
    lastWeight: '370',
    purchaseDate: '2023-04-15',
    purchaseAmount: '750',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-18',
    tag: '18',
    sex: 'Sow',
    group: '2',
    status: 'Sow Group',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2023-02-15',
    lastWeight: '462',
    purchaseDate: '2024-04-15',
    purchaseAmount: '750',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-19',
    tag: '19',
    sex: 'Sow',
    group: '2',
    status: 'Sow Group',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2023-03-06',
    lastWeight: '414',
    purchaseDate: '2023-04-15',
    purchaseAmount: '750',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-21',
    tag: '21',
    sex: 'Sow',
    group: '3',
    status: 'Sow Group',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2023-02-15',
    lastWeight: '388',
    purchaseDate: '2023-04-15',
    purchaseAmount: '750',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-22',
    tag: '22',
    sex: 'Sow',
    group: '2',
    status: 'Sow Group',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2023-02-15',
    lastWeight: '395',
    purchaseDate: '2023-04-15',
    purchaseAmount: '750',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-25',
    tag: '25',
    sex: 'Boar',
    group: '',
    status: 'Boar Group',
    breed: 'Duroc/Berkshire Cross',
    origin: 'Born on Farm',
    birthDate: '2023-05-17',
    lastWeight: '396',
    purchaseDate: '',
    purchaseAmount: '',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-27',
    tag: '27',
    sex: 'Sow',
    group: '3',
    status: 'Sow Group',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2023-02-15',
    lastWeight: '377',
    purchaseDate: '2023-04-15',
    purchaseAmount: '750',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-28',
    tag: '28',
    sex: 'Sow',
    group: '3',
    status: 'Sow Group',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2023-02-15',
    lastWeight: '360',
    purchaseDate: '2023-04-15',
    purchaseAmount: '750',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-32',
    tag: '32',
    sex: 'Gilt',
    group: '3',
    status: 'Sow Group',
    breed: 'Duroc/Berkshire Cross',
    origin: 'Born on Farm',
    birthDate: '2024-09-18',
    lastWeight: '',
    purchaseDate: '',
    purchaseAmount: '',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-33',
    tag: '33',
    sex: 'Sow',
    group: '3',
    status: 'Sow Group',
    breed: 'Berkshire',
    origin: 'Born on Farm',
    birthDate: '2024-09-18',
    lastWeight: '',
    purchaseDate: '',
    purchaseAmount: '',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-34',
    tag: '34',
    sex: 'Sow',
    group: '3',
    status: 'Sow Group',
    breed: 'Berkshire',
    origin: 'Born on Farm',
    birthDate: '2024-09-18',
    lastWeight: '',
    purchaseDate: '',
    purchaseAmount: '',
    notes: '',
    archived: false,
  },
  {
    id: 'podio-98',
    tag: '98',
    sex: 'Sow',
    group: '1',
    status: 'Deceased',
    breed: 'Berkshire',
    origin: 'Corey Davis',
    birthDate: '2023-02-15',
    lastWeight: '361',
    purchaseDate: '2023-04-15',
    purchaseAmount: '750',
    notes: '',
    archived: true,
  },
];

// Historical farrowing records imported from Podio export
export const INITIAL_FARROWING = [
  {
    id: 'f1',
    sow: '5',
    group: '2',
    farrowingDate: '2025-11-13',
    exposureStart: '2025-07-02',
    exposureEnd: '2025-08-13',
    sire: 'MACHINE',
    motheringQuality: 'excellent',
    demeanor: 'Meanest mom in a good defensive way',
    totalBorn: 11,
    deaths: 3,
    location: 'outside-pen',
    wentWell: 'She aggressively defends her piglets',
    didntGoWell: 'Crushing day 5',
    defects:
      '1 doa, 1 dead within 24 hours, one crushed around day 5. 2 runts, one recovered decently, one is still much smaller than rest of batch at 2.5 months old.\n\nMinor prolapse.',
  },
  {
    id: 'f2',
    sow: '19',
    group: '2',
    farrowingDate: '2025-11-11',
    exposureStart: '2025-07-02',
    exposureEnd: '2025-08-13',
    sire: 'MACHINE',
    motheringQuality: 'excellent',
    demeanor: 'no complaints. Solid mother.',
    totalBorn: 7,
    deaths: 1,
    location: 'outside-pen',
    wentWell: 'no deaths after 24 hours',
    didntGoWell: '',
    defects: '1 newborn death - no defects',
  },
  {
    id: 'f3',
    sow: '2',
    group: '2',
    farrowingDate: '2025-11-04',
    exposureStart: '2025-07-02',
    exposureEnd: '2025-08-13',
    sire: 'MACHINE',
    motheringQuality: 'average',
    demeanor: 'Very very protective',
    totalBorn: 9,
    deaths: 4,
    location: 'outside-pen',
    wentWell: 'Very protective',
    didntGoWell:
      'Wish she picked hut with hay over bush nest. One piglet was killed during commotion with other moms when moved into different farrowing paddock.',
    defects:
      'One DOA, one thought a different mama was hers after 1 day and died, one was crushed after 2 days. Last one is only one you can really blame her for. One was killed about a week later when they were moved into other Paddock by other mom.',
  },
  {
    id: 'f4',
    sow: '13',
    group: '2',
    farrowingDate: '2025-10-29',
    exposureStart: '2025-07-02',
    exposureEnd: '2025-08-13',
    sire: 'MACHINE',
    motheringQuality: 'excellent',
    demeanor: 'Very protective',
    totalBorn: 7,
    deaths: 0,
    location: 'outside-pen',
    wentWell: 'All alive, very protective, made her own nest',
    didntGoWell: '0',
    defects: '0',
  },
  {
    id: 'f5',
    sow: '6',
    group: '1',
    farrowingDate: '2025-08-24',
    exposureStart: '2025-03-24',
    exposureEnd: '2025-05-05',
    sire: 'MACHINE',
    motheringQuality: 'average',
    demeanor: "Doesn't want you in the pen with her",
    totalBorn: 10,
    deaths: 2,
    location: 'inside-hut',
    wentWell: 'Hay bedding seemed an improvement on 0 bedding',
    didntGoWell: 'Silver dog panels are easy for them to move and escape. Also easy for piglets to escape with those',
    defects:
      "One has an extremely large growth on back leg, but currently still alive\n\nOne was crushed by mama\n\nOne was walking on wrists on both back legs, had no chance, couldn't stand after 2 days",
  },
  {
    id: 'f6',
    sow: '17',
    group: '1',
    farrowingDate: '2025-08-18',
    exposureStart: '2025-03-24',
    exposureEnd: '2025-05-05',
    sire: 'AO',
    motheringQuality: 'excellent',
    demeanor: 'Bit a piglet from #3 unprovoked a day before she gave birth',
    totalBorn: 9,
    deaths: 1,
    location: 'outside-pen',
    wentWell: 'High survival rate outside pen',
    didntGoWell: '',
    defects: '0\n\nAO father',
  },
  {
    id: 'f7',
    sow: '98',
    group: '1',
    farrowingDate: '2025-08-11',
    exposureStart: '2025-03-24',
    exposureEnd: '2025-05-05',
    sire: 'MACHINE',
    motheringQuality: 'average',
    demeanor: 'Friendly',
    totalBorn: 11,
    deaths: 7,
    location: 'inside-hut',
    wentWell: 'Put in pen just hours before birth',
    didntGoWell: 'She broke out twice, had to rebuild pen next to her as she was 40 yards away in morning',
    defects: '4 possible doa, 3 crushed after being alive',
  },
  {
    id: 'f8',
    sow: '3',
    group: '1',
    farrowingDate: '2025-08-11',
    exposureStart: '2025-03-24',
    exposureEnd: '2025-05-05',
    sire: 'AO',
    motheringQuality: '',
    demeanor: 'Friendly, no issues',
    totalBorn: 4,
    deaths: 1,
    location: '',
    wentWell: 'put into pen post birth to grow for a few days',
    didntGoWell: 'one piglet was bitten by another sow #17 unprovoked, he shook it off and is doing fine',
    defects: 'possible 1 DOA, small and never seen alive',
  },
  {
    id: 'f9',
    sow: '7',
    group: '1',
    farrowingDate: '2025-08-05',
    exposureStart: '2025-03-24',
    exposureEnd: '2025-05-05',
    sire: 'MACHINE',
    motheringQuality: 'average',
    demeanor: 'Friendly, no issues',
    totalBorn: 10,
    deaths: 4,
    location: 'outside-hut',
    wentWell: '',
    didntGoWell: '',
    defects: '',
  },
  {
    id: 'f10',
    sow: '9',
    group: '3',
    farrowingDate: '2025-07-17',
    exposureStart: '2025-03-24',
    exposureEnd: '2025-05-05',
    sire: 'AO',
    motheringQuality: 'poor',
    demeanor: '',
    totalBorn: 11,
    deaths: 11,
    location: 'outside-pen',
    wentWell: '',
    didntGoWell: 'Better shade paddocks when pregnant, or potentially no summer farrowing',
    defects: 'Premature. Most died immediately, oldest only lasted 2 days',
  },
  {
    id: 'f11',
    sow: '2',
    group: '2',
    farrowingDate: '2024-09-08',
    exposureStart: '',
    exposureEnd: '',
    sire: 'MACHINE',
    motheringQuality: 'average',
    demeanor: 'nightmare to get into farrowing pen',
    totalBorn: 7,
    deaths: 1,
    location: '',
    wentWell: '',
    didntGoWell: "one piglet was crushed by hay under waterer, probably wasn't packed down enough or too much was used",
    defects: '',
  },
  {
    id: 'f12',
    sow: '10',
    group: '2',
    farrowingDate: '2024-07-25',
    exposureStart: '',
    exposureEnd: '',
    sire: 'AO',
    motheringQuality: '',
    demeanor: '',
    totalBorn: 11,
    deaths: 1,
    location: '',
    wentWell: '',
    didntGoWell: '',
    defects: 'one crushed',
  },
  {
    id: 'f13',
    sow: '5',
    group: '2',
    farrowingDate: '2024-07-19',
    exposureStart: '',
    exposureEnd: '',
    sire: '',
    motheringQuality: '',
    demeanor: 'aggressive when getting into pen with her',
    totalBorn: 8,
    deaths: 1,
    location: 'outside-pen',
    wentWell: 'built pen around her after birth',
    didntGoWell: '',
    defects: '0, crushed piglet 3 days after birth',
  },
];
